// this is a dummy file

import React from 'react'
import './Footer.css'


export default function Footer() {
  return (
    <div className="footer">Copyright @2023 bit by bit</div>
  )
}